import React from "react";
import { Link } from "react-router-dom";
import {
  FaRocket,
  FaCoins,
  FaHeadset,
  FaShieldAlt,
  FaUserCheck,
  FaCogs,
} from "react-icons/fa";

const WhyChooseUs = () => {
  const features = [
    {
      icon: <FaRocket />,
      title: "Easy Agent Onboarding",
      description:
        "Get started in minutes with simple KYC and instant ID activation. No technical knowledge required.",
    },
    {
      icon: <FaCoins />,
      title: "Highest Commissions",
      description:
        "Earn up to ₹50 per PAN application and competitive margins on recharges, bill payments, and insurance.",
    },
    {
      icon: <FaCogs />,
      title: "Powerful APIs",
      description:
        "Integrate our PAN, BBPS, and recharge APIs seamlessly. Detailed documentation and sandbox environment included.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Bank‑Grade Security",
      description:
        "All transactions are encrypted and fully compliant with PCI DSS standards. Your data is always safe.",
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Dedicated Support",
      description:
        "Get help via WhatsApp, phone, or ticket system. Our support team is always available for you.",
    },
    {
      icon: <FaUserCheck />,
      title: "Zero Hidden Fees",
      description:
        "No setup costs, no annual charges. You only pay for what you use – transparent and fair.",
    },
  ];

  return (
    <>
      <div
        className="works-inner-section-area"
        style={{ paddingBottom: "80px" }}
      >
        <div className="container">
          {/* Section Title (Centered) */}
          <div className="row">
            <div className="col-lg-8 m-auto">
              <div className="service-header text-center heading10">
                <h5>
                  <img src="assets/img/icons/logo-icons6.svg" alt="" />
                  Why Choose Us
                </h5>
                <h2 className="text-anime-style-3">The Panmitra Advantage</h2>
              </div>
            </div>
          </div>

          <div className="row align-items-center pt-4">
            {/* Left Column: Reasons List */}
            <div className="col-lg-7">
              <div className="works-header-area heading2">
                <div className="works-content-box">
                  <div className="icons">
                    <img
                      src="assets/img/icons/works-icons7.svg"
                      alt="All Services"
                    />
                  </div>
                  <div className="content">
                    <a href="/services">One Platform – All Services</a>
                    <p>
                      PAN card (NSDL/UTI), mobile/DTH recharge, utility bill
                      payments, motor insurance, and API solutions – all
                      integrated into a single dashboard.
                    </p>
                  </div>
                </div>
                <div className="space20" />

                <div className="works-content-box">
                  <div className="icons">
                    <img
                      src="assets/img/icons/works-icons8.svg"
                      alt="Secure & Reliable"
                    />
                  </div>
                  <div className="content">
                    <a>Secure & Reliable Platform</a>
                    <p>
                      99.9% uptime, bank‑grade encryption, and fully compliant
                      with industry standards. Your data and transactions are
                      always safe.
                    </p>
                  </div>
                </div>
                <div className="space20" />

                <div className="works-content-box">
                  <div className="icons">
                    <img
                      src="assets/img/icons/works-icons9.svg"
                      alt="24/7 Support"
                    />
                  </div>
                  <div className="content">
                    <a>24/7 Dedicated Support</a>
                    <p>
                      Get help anytime via phone, WhatsApp, or ticket system. A
                      dedicated relationship manager for every agent.
                    </p>
                  </div>
                </div>
                <div className="space20" />

                <div className="works-content-box">
                  <div className="icons">
                    <img
                      src="assets/img/icons/works-icons8.svg"
                      alt="Easy Onboarding"
                    />
                  </div>
                  <div className="content">
                    <a>Easy Onboarding</a>
                    <p>
                      Simple KYC, instant ID activation, and no technical skills
                      required. Start your business in minutes.
                    </p>
                  </div>
                </div>
                <div className="space20" />

                <div className="works-content-box">
                  <div className="icons">
                    <img
                      src="assets/img/icons/works-icons9.svg"
                      alt="Powerful APIs"
                    />
                  </div>
                  <div className="content">
                    <a>Powerful APIs</a>
                    <p>
                      Integrate PAN, BBPS, recharge, and insurance APIs
                      seamlessly. Detailed documentation and sandbox environment
                      included.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Image Grid (as per original design) */}
            <div className="col-lg-5">
              <img
                src="/images/why-choose.jpg"
                alt="Panmitra Office"
                className="img-fluid rounded-4 shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyChooseUs;
